'use strict';

module.exports = require('./is-implemented')()
	? Math.sign
	: require('./shim');



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/math/sign/index.js
// module id = 844
// module chunks = 4